// src/pages/TermsConditionsSaitruptiCabs.jsx
import React from 'react';
import { Helmet } from 'react-helmet';
import '../css/TermsConditions.css'; // Ensure your CSS file has styles for this component

const TermsConditionsSaitruptiCabs = () => {
  return (
    <div>
      <Helmet>
        <title>Saitrupti Cabs - Terms & Conditions</title>
        <meta name="description" content="Terms & Conditions of Saitrupti Cabs" />
        <link rel="canonical" href="https://www.saitrupticabs.com/terms-conditions" />
      </Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>Terms & Conditions</h1>
          </div>
        </div>
      </section>

      {/* Terms Section */}
      <section className="terms-section">
        <div className="container">
          <div className="row g-0">
            <div className="col-md-7">
              <div className="terms-content">
                <p>
                  <b className="highlight">1. Booking Confirmation:</b> 
                  All bookings with <b>Saitrupti Cabs</b> are subject to availability and are confirmed once payment is received and a booking ID is generated.
                </p>

                <p>
                  <b className="highlight">2. Payment:</b> 
                  Full fare or advance payment must be made at the time of booking. Payments can be made through our secure online portal or via authorized agents.
                </p>

                <p>
                  <b className="highlight">3. Cancellation and Rescheduling:</b> 
                  Cancellations or modifications to bookings must follow our cancellation policy. Applicable charges may vary depending on notice period.
                </p>

                <p>
                  <b className="highlight">4. Passenger Responsibility:</b> 
                  Passengers must carry valid ID proof and booking details. Saitrupti Cabs reserves the right to deny service if verification is not provided.
                </p>

                <p>
                  <b className="highlight">5. Baggage Policy:</b> 
                  Passengers may carry reasonable luggage. Excess or oversized baggage may attract additional charges and is subject to vehicle capacity.
                </p>

                <p>
                  <b className="highlight">6. Travel Insurance:</b> 
                  Saitrupti Cabs does not provide travel insurance. Customers are advised to obtain their own insurance for coverage.
                </p>

                <p>
                  <b className="highlight">7. Safety Regulations:</b> 
                  All passengers must follow driver instructions and use seatbelts during the ride. Misconduct or unsafe behavior may result in cancellation of the trip.
                </p>

                <p>
                  <b className="highlight">8. Changes to Itinerary:</b> 
                  Saitrupti Cabs may alter or cancel services due to unforeseen circumstances such as weather, technical issues, or government restrictions.
                </p>

                <p>
                  <b className="highlight">9. Refusal of Service:</b> 
                  Service may be refused to individuals found violating terms, engaging in unlawful activity, or posing a safety risk to others.
                </p>

                <p>
                  <b className="highlight">10. Jurisdiction:</b> 
                  All terms are governed by Indian laws. Any legal disputes will fall under the jurisdiction of Pune courts.
                </p>

                <h3>General Policy</h3>
                <p>
                  <b className="highlight">Booking Procedure:</b> 
                  Bookings can be made online, through our mobile app, or by contacting customer support.
                </p>
                <p>
                  <b className="highlight">Customer Support:</b> 
                  Our dedicated team is available 24/7 to assist with booking, cancellations, and other concerns.
                </p>

                <h3>Refund Policy</h3>
                <p>
                  <b className="highlight">Cancellation Charges:</b> 
                  Refunds are subject to applicable cancellation fees as per Saitrupti Cabs’ cancellation policy.
                </p>
                <p>
                  <b className="highlight">Refund Process:</b> 
                  Approved refunds are processed to the original payment method within 7–10 business days.
                </p>
                <p>
                  <b className="highlight">No-Show Policy:</b> 
                  Failure to appear at the pickup location at the scheduled time will result in a no-show, and no refund will be issued.
                </p>
              </div>
            </div>
          </div>

          {/* Contact Info */}
          <div className="contact-info">
            <h2>Contact Us</h2>
            <p>If you have any questions or need further clarification, please contact us:</p>
            <ul>
              <li>
                <b>Phone:</b> <a href="tel:+918390907004">+91 8390907004</a> {/* Update actual number */}
              </li>
              <li>
                <b>Email:</b> <a href="mailto:booking@saitrupticabs.com">booking@saitrupticabs.com</a>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsConditionsSaitruptiCabs;
